<template>
  <div class="card mt-3">
    <header class="card-header">
      <p class="card-header-title has-background-info-light has-text-info-dark">
        Graf Trofeja
      </p>
    </header>
    <div class="card-content">
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VueFusionChartsComponent from 'vue-fusioncharts/component';

// import FusionCharts modules and resolve dependency
import FusionCharts from 'fusioncharts';
import TimeSeries from 'fusioncharts/fusioncharts.timeseries';

const vueFusionCharts = VueFusionChartsComponent(FusionCharts, TimeSeries);

Vue.component('fusioncharts', vueFusionCharts);

export default {};
</script>

<style></style>
